<template>
    <svg
        class="icon-secure"
        viewBox="0 0 45 26"
        xmlns="http://www.w3.org/2000/svg"
    ><path d="M29.87,11.91V8.67H.4v8.86a5,5,0,0,0,5,5H25.92V14.86a3,3,0,0,1,3-2.95Z" /><path d="M35,5a5,5,0,0,0-5-5H5A5,5,0,0,0,0,5V7H35Z" /><path d="M41.31,13V13c0-2-1.67-4.39-3.73-4.39H35.19c-2.06,0-3.73,2.44-3.73,4.39v.08A4,4,0,0,0,28,17v5a4,4,0,0,0,4,4h9a4,4,0,0,0,4-4V17A4,4,0,0,0,41.31,13Zm-6.79-1.44a1.23,1.23,0,0,1,.67-.51h2.39a1.21,1.21,0,0,1,.68.51A2.54,2.54,0,0,1,38.81,13v0H34v0A2.56,2.56,0,0,1,34.52,11.59Z" /></svg>
</template>